import { useMemo } from 'react';
import { QUERY_PARAM } from '@config/routing';
import { toUserAchievements } from '@helpers/member';
import { ROUTES } from '@routing/routes';
import { Link } from '@managers/links/link';
import { MemberCard } from '@kit/member-card';
import { TopMembersListItemWidgetProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export const TopMembersListItemWidget: React.FC<TopMembersListItemWidgetProps> = props => {
  const {
    className,
    item
  } = props;
  const achievements = useMemo(() => toUserAchievements(item.isCertified, item.profSpeciality), [item.isCertified, item.profSpeciality]);
  const routeDescriptor = useMemo(() => {
    return ROUTES.psychologists.id //
    .getDescriptor({
      [QUERY_PARAM.PATHNAME_SPECIALIST_ID]: item.userId
    }, {
      withBackTo: true,
      withScrollY: true
    });
  }, [item.userId]);
  return _jsx(Link //
  , {
    className: className,
    routeDescriptor: routeDescriptor,
    children: _jsx(MemberCard, {
      ...item,
      achievements
    })
  });
};